import { render, staticRenderFns } from "./logisticsMgmt.vue?vue&type=template&id=786013fe"
import script from "./logisticsMgmt.vue?vue&type=script&lang=js"
export * from "./logisticsMgmt.vue?vue&type=script&lang=js"
import style0 from "./logisticsMgmt.vue?vue&type=style&index=0&id=786013fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports